export default __webpack_public_path__ + "static/media/feel-the-magic.698ecb83.png";